// removed by extract-text-webpack-plugin
module.exports = {"ReactModal__Body--open":"ReactModal__Body--open","term-open":"term-open","root":"root","ReactModal__Overlay":"ReactModal__Overlay","term-popup-content-wrap":"term-popup-content-wrap","btn-close-term":"btn-close-term"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/terms-of-use/style.scss
// module id = ./components/partials/terms-of-use/style.scss
// module chunks = 0